var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6372 10.1589L15.1802 17.2574C15.1227 17.3451 15.0259 17.3996 14.923 17.3996H9.37068C9.25872 17.3996 9.15888 17.3391 9.10439 17.2423C9.0499 17.1484 9.05294 17.0304 9.11345 16.9366L13.4736 9.99843L9.11345 3.06331C9.05294 2.96952 9.0499 2.85151 9.10439 2.75769C9.15884 2.66089 9.25868 2.60034 9.37068 2.60034H14.923C15.0259 2.60034 15.1227 2.65483 15.1802 2.74257L19.6372 9.83808C19.6977 9.93491 19.6977 10.0621 19.6372 10.1589Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17372 17.3999C6.2779 17.3999 6.37466 17.3465 6.42989 17.2581L10.8871 10.159C10.949 10.0609 10.949 9.93561 10.8871 9.83721L6.42993 2.74162C6.37454 2.65357 6.27774 2.6001 6.17376 2.6001H0.620008C0.50993 2.6001 0.408446 2.6601 0.355086 2.75643C0.301883 2.85275 0.305164 2.97037 0.363797 3.06373L4.72313 9.99826L0.363836 16.9363C0.305164 17.0297 0.301922 17.1473 0.355282 17.2437C0.408485 17.3403 0.509969 17.4 0.620047 17.4H6.17372V17.3999ZM5.33677 10.1593C5.39868 10.0609 5.39868 9.93561 5.33677 9.83721L1.1677 3.20525H6.00649L10.2736 9.99826L6.00649 16.7948H1.16755L5.33677 10.1593Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHit);
export default __webpack_public_path__ + "static/media/hit.8df7133a8068fb7de0f6ce21ef36dc4a.svg";
export { ForwardRef as ReactComponent };